import ChooseServiceDivisionGroup from '@/components/forms/form-choose-service-division-group/ChooseServiceDivisionGroup';
import { Skeleton } from '@/components/ui/skeleton';
import { useRootStore } from '@/stores/root-store';
import { ChooseServiceDivisionStepProps } from './chooseServiceDivision.types';

const ChooseServiceDivisionStep: React.FC<ChooseServiceDivisionStepProps> = ({
  organization,
}) => {
  const stepServicesData = useRootStore((store) => store.stepServicesData);

  if (!stepServicesData?.service?.rangeDivisions) {
    return <Skeleton className="w-full h-96" />;
  }

  return (
    <ChooseServiceDivisionGroup
      serviceDivisionGroups={stepServicesData?.service?.rangeDivisions}
      organization={organization}
    />
  );
};

export default ChooseServiceDivisionStep;
